import * as React from 'react';

import { cn } from '@/utils';

export interface BatchFilterButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  showDot?: boolean;
  dotColor?: string;
  children: React.ReactNode;
}

const BatchFilterButton = React.forwardRef<
  HTMLButtonElement,
  BatchFilterButtonProps
>(
  (
    { className, selected, showDot = true, dotColor, children, ...props },
    ref
  ) => {
    const defaultDotColorClass = selected
      ? 'bg-nirvana-jewel'
      : 'bg-underwater-fern-green-dark';

    return (
      <button
        className={cn(
          'inline-flex items-center justify-center gap-2.5 px-4 py-1.5 rounded-lg font-semibold text-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bhanzu-orange cursor-pointer disabled:pointer-events-none disabled:opacity-50 bg-magical-moonlight-s text-magical-moonlight-d2 data-[selected=true]:bg-white data-[selected=true]:border data-[selected=true]:border-magical-moonlight-d2',
          className
        )}
        data-selected={selected}
        ref={ref}
        {...props}
      >
        {!!showDot && (
          <div
            className={cn(
              'w-2 h-2 rounded-lg shrink-0',
              !dotColor && defaultDotColorClass
            )}
            style={dotColor ? { backgroundColor: dotColor } : undefined}
          />
        )}
        <span className="whitespace-nowrap text-sm">{children}</span>
      </button>
    );
  }
);
BatchFilterButton.displayName = 'BatchFilterButton';

export default BatchFilterButton;
